import { DistanceConversionFactors } from "./DistanceConversionFactors";
import { DistanceUnits } from "./DistanceUnits";
import { NumberWithUnit, NumberWithUnitConstructor, UnitSource } from "./NumberWithUnit";
import { Unit } from "./Unit";
import { UnitConversionFactorGroup } from "./UnitConversionFactorGroup";

export class Distance extends NumberWithUnit {
    protected override get cls(): NumberWithUnitConstructor {
        return Distance;
    }

    public override get unitGroup(): DistanceUnits {
        return DistanceUnits.singleton;
    }

    public override convert(targetUnit: UnitSource): number {
        const targetUnitAbbreviation = Unit.resolveAbbreviation(targetUnit);
        return this.convertWithPrecision(targetUnitAbbreviation, 2);
    }

    public override getConversionFactors(): UnitConversionFactorGroup {
        return DistanceConversionFactors.get();
    }
}
